module.exports = __webpack_public_path__ + "img/performance.9bd9952e.svg";